var React = require('react');

function SliderArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_60","data-name":"Path 60","d":"M4258.99,2012.074l-25-25,25-25","transform":"translate(-4231.989 -1959.246)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"}));
}

SliderArrow.defaultProps = {"width":"29.829","height":"55.657","viewBox":"0 0 29.829 55.657"};

module.exports = SliderArrow;

SliderArrow.default = SliderArrow;
